var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRewardIcon = function SvgRewardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.738 7.868.518-.434c.12-.101.272-.156.429-.156h.676c.323 0 .6-.232.657-.551l.117-.666a.67.67 0 0 1 .228-.395l.518-.434a.666.666 0 0 0 .149-.844l-.338-.586a.67.67 0 0 1-.08-.45l.118-.666a.67.67 0 0 0-.43-.742l-.634-.231a.67.67 0 0 1-.35-.293L5.978.834A.67.67 0 0 0 5.173.54l-.635.232a.67.67 0 0 1-.456 0L3.446.54a.666.666 0 0 0-.805.294l-.338.586a.67.67 0 0 1-.35.293l-.635.231a.67.67 0 0 0-.428.742l.117.666a.67.67 0 0 1-.08.45l-.337.586c-.162.28-.1.636.148.844l.518.434c.12.101.2.241.228.395l.118.666c.056.319.333.55.656.55h.676c.157 0 .309.056.429.157l.518.434c.248.208.61.208.857 0M6.476 8.946v2.334L4.309 9.613 2.143 11.28V8.946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.31 5.595a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666"
  })));
};
export default SvgRewardIcon;